module.exports = __webpack_public_path__ + "img/STHander_Sword Two-Hander Blue.9f709a04.png";